import { Col, Row } from "antd";
import _ from "lodash";
import React from "react";
import { HomePageLayout } from "../HomePageLayout";
import step1ImageSrc from "./images/step1.png";
import step2ImageSrc from "./images/step2.png";
import step3ImageSrc from "./images/step3.png";
import step4ImageSrc from "./images/step4.png";
import stepDashLineSrc from "./images/stepDashLine.png";
import "./index.scss";

interface IFlowItem {
  description: string;
  imageSrc: string;
}

const flowItems: ReadonlyArray<IFlowItem> = [
  {
    description: "1. 提交申请",
    imageSrc: step1ImageSrc
  },
  {
    description: "",
    imageSrc: stepDashLineSrc
  },
  {
    description: "2. 资质审核",
    imageSrc: step2ImageSrc
  },
  {
    description: "",
    imageSrc: stepDashLineSrc
  },
  {
    description: "3. 签订协议",
    imageSrc: step3ImageSrc
  },
  {
    description: "",
    imageSrc: stepDashLineSrc
  },
  {
    description: "4. 展开合作",
    imageSrc: step4ImageSrc
  }
];

const cls = "ApprovalFlowWall";

export class ApprovalFlowWall extends React.PureComponent {
  approvalFlowItemRender(flowItem: IFlowItem) {
    const { description, imageSrc } = flowItem;
    const flowItemCls = "ApprovalFlowItem";
    return (
      <div className={`${flowItemCls}`}>
        <img className={`${flowItemCls}-image`} src={imageSrc} />
        <div className={`${flowItemCls}-title`}>{description}</div>
      </div>
    );
  }

  render() {
    return (
      <HomePageLayout
        className={`${cls}`}
        title={<span className={`${cls}-title`}>申请流程</span>}
      >
        <Row type="flex" justify="space-between">
          {_.map(flowItems, (flowItem, idx) => {
            if (idx % 2 === 0) {
              return (
                <Col xs={4} md={4} key={idx}>
                  {this.approvalFlowItemRender(flowItem)}
                </Col>
              );
            } else {
              return (
                <Col xs={2} md={2} key={idx}>
                  {this.approvalFlowItemRender(flowItem)}
                </Col>
              );
            }
          })}
        </Row>
      </HomePageLayout>
    );
  }
}
